export default "__VITE_ASSET__DtMLakVQ__"